import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { Skeleton } from 'antd';
import { useMethods } from '@lhb/hook';
import styles from './index.module.less';

const LazyModule: FC<{ children: ReactNode; root?: HTMLElement; active: boolean }> = ({ children, root, active }) => {
  const host = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(active);
  const methods = useMethods({
    observe(entries: IntersectionObserverEntry[]) {
      if (entries.some(entry => entry.isIntersecting)) setVisible(true);
    },
  });
  useEffect(() => {
    if (visible) return;
    if (active || !window.IntersectionObserver) { setVisible(true); return; }
    const observer = new IntersectionObserver(methods.observe, { root: root || null, rootMargin: '200px' });
    if (host.current) observer.observe(host.current);
    return () => observer.disconnect();
  }, [active, root, visible]);
  return <div ref={host} className={styles.module}>{visible ? children : <Skeleton active paragraph={{ rows: 5 }} />}</div>;
};
export default LazyModule;
